import { LinePlusCircle } from '@qr-front/icons/line-plus-circle'
import { Button } from '@qr-front/ui/components/Button'
import { subExpiredDialogAtom } from 'features/library/client'
import { useAtomValue, useSetAtom } from 'jotai'
import { useTranslations } from 'next-intl'
import { UserStatusEnum } from 'types/subscription'

import { ROUTES } from '@/constants'
import { userAtom } from '@/global-state'
import { Link } from '@/i18n-routing'
import { getTrialRemainingTime } from '@/utils'

import QrCodePlaceholder from './QrCode'

export const NoCodesState = () => {
	const t = useTranslations()

	const user = useAtomValue(userAtom)
	const userTrial = getTrialRemainingTime(
		user?.createdAt,
		user?.flowData?.freeDaysQuota,
	)
	const isTrialExpired =
		userTrial.expired && user?.status === UserStatusEnum.FREEMIUM_OLD

	const enableExpiredDialog =
		isTrialExpired ||
		(userTrial.expired &&
			[
				UserStatusEnum.PREMIUM_IN_DEBT,
				UserStatusEnum.DEACTIVATED,
			].includes(user?.status as UserStatusEnum)) ||
		user?.status === UserStatusEnum.PREMIUM_CANCELLED ||
		user?.status === UserStatusEnum.PREMIUM_IN_DEBT

	const setTrialExpiredDialogAtom = useSetAtom(subExpiredDialogAtom)

	return (
		<div className="flex flex-col items-center justify-center gap-4 px-0 pb-0 pt-30">
			<div className="flex items-center gap-2 rounded-8 bg-white p-2">
				<QrCodePlaceholder />
			</div>
			<span className="type-heading-4">
				{t('dashboard__qr_table__no_codes__title')}
			</span>
			<Link
				href={ROUTES.generator.typeStep}
				onClick={(event) => {
					if (isTrialExpired || enableExpiredDialog) {
						event.preventDefault()
						setTrialExpiredDialogAtom(true)
					}
				}}
			>
				<Button className="h-12 px-6 text-body-large font-semibold">
					<LinePlusCircle className="size-6" />
					{t('dashboard__shared__cta_button')}
				</Button>
			</Link>
		</div>
	)
}
